/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const User = zod
	.object({
		email: zod.email().describe('Email address'),
		environment_id: zod.string().nullable().describe('Environment ID'),
		fullName: zod.string().nullable().describe('Full name'),
		id: zod.string().describe('User ID'),
		organization_id: zod.string().nullable().describe('Organization ID')
	})
	.describe('A user account');

export type User = zod.input<typeof User>;
export type UserOutput = zod.output<typeof User>;
